import type {
  InputDescription,
  Layout,
} from "@smartsuite/automation-engine-api";
import { Position } from "@smartsuite/automation-engine-api";
import styled from "styled-components";
import { injectInputColumnsResponsiveStyles } from "../../Forms/InputForm/input-columns-responsive-styles";

injectInputColumnsResponsiveStyles();

export const StyledIconCloseContainer = styled.button`
  position: absolute;
  right: 30px;
  top: 18px;
  background: none;
  cursor: pointer;
  z-index: 2;
`;

export const StyledActionInputsContainer = styled.div`
  div {
    vertical-align: top;
  }
`;

export const StyledInputWrapper = styled.div.attrs<{
  layout?: Layout;
  nextInputDescription?: InputDescription;
}>(({ layout, nextInputDescription }) => ({
  className: [
    layout?.position === Position.SAME_LINE ? "au-input-same-line" : "",
    nextInputDescription?.editor?.layout?.position === Position.SAME_LINE
      ? "au-input-before-same-line"
      : "",
  ]
    .filter(Boolean)
    .join(" "),
}))<{
  layout?: Layout;
  nextInputDescription?: InputDescription;
}>`
  ${({ layout }) =>
    layout?.position === Position.SAME_LINE
      ? ""
      : `&:not(:last-child) {
    margin-bottom: 18px;
  }`};

  ${({ layout }) =>
    layout?.position === Position.SAME_LINE
      ? `display: inline-block; width: ` + String(layout?.width) + `%;`
      : `display: block;`};

  ${({ nextInputDescription }) =>
    nextInputDescription?.editor?.layout?.position === Position.SAME_LINE
      ? `padding-right: 16px;`
      : ``};
`;
